import { useMemo } from "react"
import { ComboboxField } from "@ui/forms"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { useFetchUsers } from "@/hooks/api/users"

interface UserSelectorFieldProps<T extends FieldValues> {
  field: ControllerRenderProps<T, Path<T>>
  bookIdOverride?: string
}

export function UserSelectorField<T extends FieldValues>({ field, bookIdOverride }: UserSelectorFieldProps<T>) {
  const { data: users, isLoading } = useFetchUsers(bookIdOverride)

  const options = useMemo(() => {
    return (
      users?.users?.map((user) => ({
        value: user.id,
        label: user.full_name,
      })) ?? []
    )
  }, [users?.users])

  return (
    <ComboboxField
      id="owner_id"
      label="Assigned to"
      field={field}
      options={options}
      placeholder={isLoading ? "Loading..." : "Select user"}
    />
  )
}
